import getEnvironment, { Environments } from '../utils/env';

type EndpointKeys = 'api' | 'history' | 'clientsideLogger' | 'slideshowBucket';
type EndpointsObject = Record<EndpointKeys, string>;
const staging: EndpointsObject = {
  api: 'https://federation-router.vp-stage.tv2dev.dk',
  history: 'https://history.stage-playbe-aws.tv2net.dk/history',
  clientsideLogger: 'https://cl.stage-play-aws.tv2net.dk',
  slideshowBucket: 'https://dvn8a289296ie.cloudfront.net',
};

const production: EndpointsObject = {
  api: 'https://play.tv2api.dk',
  history: 'https://history.ovp.tv2.dk/history',
  clientsideLogger: 'https://cl.play.tv2.dk/',
  slideshowBucket: 'https://d51120i5d2q6t.cloudfront.net',
};

export const Endpoints = (env: Environments) => {
  switch (env) {
    case 'stage':
      return staging;
    default:
      return production;
  }
};

export default Endpoints(getEnvironment());
